import { render, staticRenderFns } from "./MySavedItems.vue?vue&type=template&id=0f661d59&"
import script from "./MySavedItems.vue?vue&type=script&lang=js&"
export * from "./MySavedItems.vue?vue&type=script&lang=js&"
import style0 from "./MySavedItems.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports